"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoizedFlywireValidation = exports["default"] = void 0;

var _lruMemoize = _interopRequireDefault(require("lru-memoize"));

var _utils = require("../utils");

var _email = require("../utils/email");

var _phone = require("../utils/phone");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var flywireValidation = (0, _utils.createValidator)({
  amount: [_utils.required, _utils.integer],
  firstName: _utils.required,
  lastName: _utils.required,
  address: [_utils.required, (0, _utils.minLength)(5), _utils.noPOBox],
  city: _utils.required,
  country: _utils.required,
  email: [_utils.required, _email.email],
  phone: [_utils.required, _phone.phone]
});
var memoizedFlywireValidation = exports.memoizedFlywireValidation = (0, _lruMemoize["default"])(10)(flywireValidation);

var _default = exports["default"] = flywireValidation;